define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var config = require('config');
    var i18n = require('i18n');

    module.exports = {
        notify: function(response) {
            if (response.ID === 33015 && config.get('sendCashierMessagesToGS')) {
                return false;
            }

            _.map(response.data.payments.transaction, function(transaction) {
                window.Playtech.API.popup.showPopup({
                    title: this._getTitle(response.ID),
                    content: transaction.message
                });
            }.bind(this));
        },

        _getTitle: function(id) {
            var type = id === 33015 ? 'deposit' : 'withdraw';

            return i18n.t('playtech.mobile.system.mobile-cashier.' + type + '.title');
        }
    };
});
